import React from 'react';
import ImageUpload from './ImageUpload';

interface EmployeeImageUploadProps {
  employeeId: string;
  employeeName: string;
  currentImageUrl?: string;
  onImageUpdated?: (imageUrl: string) => void;
}

const EmployeeImageUpload: React.FC<EmployeeImageUploadProps> = ({
  employeeId,
  employeeName,
  currentImageUrl,
  onImageUpdated
}) => {
  const handleUploadSuccess = (imageUrl: string) => {
    console.log(`Employee image uploaded successfully: ${imageUrl}`);
    if (onImageUpdated) {
      onImageUpdated(imageUrl);
    }
  };

  const handleUploadError = (error: Error) => {
    console.error('Employee image upload failed:', error);
  };

  return (
    <div className="employee-image-upload">
      <h4 style={{ marginBottom: '16px' }}>Employee Photo</h4>
      <p style={{ fontSize: '14px', color: '#6c757d', marginBottom: '16px' }}>
        Upload a photo for {employeeName}
      </p>
      <ImageUpload
        uploadType="employee"
        entityId={employeeId}
        currentImageUrl={currentImageUrl}
        onUploadSuccess={handleUploadSuccess}
        onUploadError={handleUploadError}
        maxSizeMB={5}
        acceptedFormats={['image/jpeg', 'image/png']}
      />
    </div>
  );
};

export default EmployeeImageUpload;